import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Cart context
import { CartProvider } from './context/CartContext'; // adjust path if needed

// TanStack Query
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './libs/queries/ClientQueries'; // this is the file we created earlier

const root = ReactDOM.createRoot(document.getElementById('root'));

// Optional: mute console noise
console.error = () => {};
console.warn = () => {};
//console.log = () => {};
//console.info = () => {};

root.render(
  <React.StrictMode>
    {/* 1. Provide query client for all React Query usage */}
    <QueryClientProvider client={queryClient}>
      {/* 2. Provide cart context */}
      <CartProvider>
        <App />
      </CartProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();